import { render, staticRenderFns } from "./situation.vue?vue&type=template&id=a2c3cb90"
import script from "./situation.vue?vue&type=script&lang=js"
export * from "./situation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports